import React, {Component} from 'react';
import {action, observable} from 'mobx';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {observer} from 'mobx-react';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import {typoLight, secondary, white} from '../../themes/colors';
import './circularProgress.scss';

const styles = () => ({
    grayLoader: {
        color: typoLight,
    },
    secondaryLoader: {
        color: secondary,
    },
    whiteLoader: {
        color: white,
    }
});

@observer
class CircularProgress extends Component {
    @observable circleProgress = 0;
    @observable offset = this.props.offset || 0;

    componentDidMount() {
        if (this.props.duration) {
            const leap = this.props.duration / 100;
            this.timer = setInterval(() => {
                this.progress(leap);
            }, 100);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    @action progress = (leap) => {
        if (this.props.pause) {
            this.offset = this.circleProgress;
            clearTimeout(this.timer);
        } else {
            this.circleProgress = this.circleProgress + leap;
        }
        if (this.circleProgress === this.props.duration) {
            this.circleProgress = 0;
        }
    };

    render() {
        const {classes, containerStyle, containerClass, colorType = 'secondaryLoader', size, duration, offset, mode,
            thickness, progressStyle, children} = this.props;
        return (
            <div style={containerStyle} className={`flexbox flex-column-wrap flex-center relative ${containerClass}`}>
                <MuiCircularProgress
                    classes={{root: classes[colorType]}} size={size} max={duration}
                    min={offset} mode={mode} thickness={thickness} value={this.circleProgress}
                    style={{...progressStyle}}/>
                {children}
            </div>
        );
    }
}

CircularProgress.propTypes = {
    offset: PropTypes.number,
    duration: PropTypes.number,
    thickness: PropTypes.number,
    size: PropTypes.number,
    containerStyle: PropTypes.object,
    containerClass: PropTypes.string,
    progressInnerStyle: PropTypes.object,
    progressStyle: PropTypes.object,
    color: PropTypes.string,
    mode: PropTypes.string,
    children: PropTypes.node,
    pause: PropTypes.bool
};

export default withStyles(styles)(CircularProgress);
